module.exports = __webpack_public_path__ + "media/header-he.8097cb3f.mp4";